export enum adminNewsCompanyDetailTypes {
    FETCH_ADMIN_NEWS_COMPANY_DETAIL_REQUEST = "FETCH_ADMIN_NEWS_COMPANY_DETAIL_REQUEST",
    FETCH_ADMIN_NEWS_COMPANY_DETAIL_SUCCESS = "FETCH_ADMIN_NEWS_COMPANY_DETAIL_SUCCESS",
    FETCH_ADMIN_NEWS_COMPANY_DETAIL_FAILURE = "FETCH_ADMIN_NEWS_COMPANY_DETAIL_FAILURE",
  }